import Icon from 'veui/components/Icon'
import { IconCellphone } from 'dls-icons-vue'

Icon.register('cellphone', IconCellphone)
